module.exports = __webpack_public_path__ + "img/wisebeyondbitcoin.4c9c6a39.png";